/**
 * Backs a table's `mapUiSortToBackendSort` (room-utilization, room-calls). Incidents-v2 still
 * maps inline against its own `SORT_FIELD_MAP` - fold it in when that table migrates.
 */
export function mapSortField<T extends { field: string }>(sort: T, resolveField: (uiField: string) => string | undefined): T {
  return { ...sort, field: resolveField(sort.field) ?? sort.field };
}
